import styles from '../../styles/ToyDetails.module.css'
import Pill from "../Pill";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { Col, Collapse, Container, Row } from "react-bootstrap";
import { useMemo, useState } from "react";
import { useAppContext } from "../../context/shared";
import BenefitLabel from "../BenefitLabel";
import { randomItem } from "../../lib/utils";

const ToyDetails = (props: {
  title: string,
  fromAge: { unit?: string, value?: number },
  description: string,
  image: string,
  footerText: string,
  benefitTags: string[],
  benefitLabelColors: string[] | null
  howToUse: string[]
}) => {

  const [open, setOpen] = useState(false)
  const { localization } = useAppContext()
  const fromAge = useMemo(() => {
    if (!props.fromAge?.unit || !props.fromAge?.value) return ''
    return localization.activity_guide_from + ' ' + props.fromAge.value + ' ' + localization['activity_guide_' + props.fromAge.unit]
  }, [props.fromAge.unit, props.fromAge.value, localization])

  return(
    <Container className='card bg-white p-0'>
      <div className='p-4'>
        <Row>
          <Col md='6'>
            <h4>{props.title}</h4>
          </Col>
          {props.fromAge && (
            <Col md='6' className='text-start text-md-end pt-3 pt-md-0'>
              <div className='d-inline-block'>
                <Pill content={fromAge} variant='secondary' />
              </div>
            </Col>
          )}
        </Row>
        <hr className='border-top border-0' />
        <Row>
          <Col md='7' lg='9' className='mb-3'>
            <div className='caption'>{props.description}</div>
          </Col>
          <Col md='5' lg='3'>
            <img src={props.image} className='border border-1 rounded-3 img-fluid' alt='' />
          </Col>
        </Row>
      </div>
      <Collapse in={open}>
        <div className={styles.detailsWrapper}>
          <div className={styles.details}>
            {props?.benefitTags?.length !== 0 && (
              <div>
                <div className={[styles.detailsTitle, 'pb-2'].join(' ')}>{localization.activity_guide_benefits}</div>
                <div className='d-flex gap-1'>
                  {props.benefitTags.map((benefitTag, index) => (
                    <BenefitLabel key={index} content={benefitTag} backgroundColor={randomItem(props.benefitLabelColors)} />
                  ))}
                </div>
              </div>
            )}
            {props?.howToUse?.length > 0 && (
              <div className={[styles.howToUseList, 'pt-4'].join(' ')}>
                <div className={[styles.detailsTitle, 'pb-2'].join(' ')}>{localization.activity_guide_how_to_use}</div>
                <ul>
                  {props.howToUse.map((howToUseItem, index) => (
                    <li key={index}><span>{howToUseItem}</span></li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </Collapse>
      <div
        className={[styles.footer, 'd-flex', (props.footerText ? 'justify-content-between' : 'justify-content-center')].join(' ')}
        onClick={() => setOpen(!open)}
      >
        <div className={styles.footerText}>{props.footerText}</div>
        <FontAwesomeIcon icon={open ? faChevronUp : faChevronDown} />
      </div>
    </Container>
  )
}

export default ToyDetails